<app-homepage [viewBank]="viewBank" [viewBranches]="viewBranches" [viewGestore]="viewGestore" [viewReport]="viewReport" [viewIntegrationTest]="viewIntegrationTest"></app-homepage>
